// extracted by mini-css-extract-plugin
module.exports = {"mainContentContainer":"_8AWoZ5x","pageContent":"_1nXhSK2","whiteOverlay":"_1jr0YTn"};